import { render } from "./Front.vue?vue&type=template&id=3e284eca&scoped=true"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"

import "./Front.vue?vue&type=style&index=0&id=3e284eca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e284eca"]])

export default __exports__